import { StandingData } from '../types';
import { EHttpMethod, usePortalQuery } from './usePortalQuery';

export const useStandingData = (): { isLoading: boolean; standingData: StandingData } => {
  const { data: standingData, isLoading } = usePortalQuery<StandingData>(
    EHttpMethod.GET,
    'standing-data',
    'get-contract-standing-data',
    true,
    undefined,
    undefined,
    undefined,
    false,
    600000, // ensure data is not stale for 10 minutes
    600000 // prevent data being garbage collected for 10 minutes
  );

  return {
    isLoading,
    standingData: {
      standingDataSiteTypeList: standingData?.standingDataSiteTypeList ?? [],
      standingDataAssetOwnershipList: standingData?.standingDataAssetOwnershipList ?? [],
      standingDataNoCommsList: standingData?.standingDataNoCommsList ?? [],
      standingDataSiteStatusList: standingData?.standingDataSiteStatusList ?? [],
      standingDataMeterWorkRequiredList: standingData?.standingDataMeterWorkRequiredList ?? [],
      standingDataJobTypeList: standingData?.standingDataJobTypeList ?? [],
      standingDataJobStatusList: standingData?.standingDataJobStatusList ?? [],
      standingDataVisitOutcomeList: standingData?.standingDataVisitOutcomeList ?? []
    }
  };
};
